var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "hover-intent",
          rawName: "v-hover-intent",
          value: _vm.hover,
          expression: "hover",
        },
      ],
      staticClass: "w-slider",
      class: [_vm.size, { hover: _vm.isHovered }, _vm.classes],
      on: {
        mousemove: _vm.seek,
        mouseleave: _vm.unhover,
        mousedown: function ($event) {
          $event.preventDefault()
          return _vm.drag.apply(null, arguments)
        },
        mouseup: function ($event) {
          $event.preventDefault()
          return _vm.stopdrag.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "content" }, [
        _c("div", { ref: "track", staticClass: "track" }, [
          _c("div", {
            ref: "bar",
            staticClass: "bar",
            style: { width: _vm.barLength },
          }),
        ]),
        _c(
          "div",
          {
            ref: "thumb",
            staticClass: "thumb",
            style: { left: _vm.thumbPos + "px" },
          },
          [_c("div", { staticClass: "inner" })]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }